import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const API_URL = process.env.REACT_APP_API_URL;

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authReducerApi',
  baseQuery: fetchBaseQuery({
     baseUrl: `${API_URL}/User/v2/`,
     prepareHeaders: (headers) => {
        // If we have a token set in state, let's assume that we should be passing it.
        // headers.set('Authorization', 'Bearer MY_TOKEN');
        headers.set('Access-Control-Allow-Origin', `${API_URL}`);
        headers.set('Access-Control-Allow-Credentials', 'include');
        headers.set('Access-Control-Allow-Methods', 'GET, POST, PUT,PATCH, DELETE, OPTIONS');
        headers.set('Content-Type', 'application/json');
       
        // console.log(headers);
        return headers;
      },

    }),
 
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (user) => {
        return {
            url: 'login',
            method: 'POST',
            body: user
        }
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation } = authApi